import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const Loader = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]">
    <div className="w-10 h-10 border-2 border-[#7A222B] border-t-transparent rounded-full animate-spin" />
  </div>
);

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}
